/**
 * 全部の投稿先に投稿済みだが、確かめてほしいことが残っている投稿のカード
 * （例: Instagram がキャプションを付けずに公開した）。注意の表示と「確認しました」は ChannelRows が出す
 * （一部だけ投稿済みの投稿でも同じ表示になるように）。
 */

import type { QueueItem } from '../../lib/postTypes'
import { InlineError } from '../../components/QueryState'
import { useQueueActions, type Notify } from './useQueueActions'
import { PostBody } from './PostBody'
import { ChannelRows } from './ChannelRows'

export function NotedCard({ item, notify }: { item: QueueItem; notify: Notify }) {
  const actions = useQueueActions(item, notify)
  return (
    <div className="gm-card p-4 text-sm">
      <PostBody item={item} badge={<span className="gm-chip gm-chip-warn shrink-0">投稿済み（要確認）</span>} />
      <ChannelRows channels={item.channels.filter(c => c.note)} actions={actions} readOnly />
      <InlineError message={actions.error?.message} issues={actions.error?.issues} className="mt-2" />
    </div>
  )
}
